import React, { useRef } from "react";
import { message } from "antd";
import { ISCMPromptFormFields } from "../promptService";
import { usePromptModel } from "../promptModel";
import { useMdmModel } from "../../../../model/mdmModel";
import { IYhFormRef, IYhForm, FormItemTypeEnum, ISelectOption } from "../../../../components2/YhFormBox/Types";
import { getFormValidatorErrText, loadDictParam } from "../../../../utils/utils";
import { AppDrawer } from "../../../../components2/YhDrawer";
import { YhForm } from "../../../../components2/YhFormBox";
import { ITreeSelectData } from "../../../../components2/YhPageHeader/Types";


export function DetailDrawer() {
    const { entity, mdmBranch, mdmOrgan, dict } = useMdmModel();
    const { promptDrawer: { visible, mode }, setIPromptDrawer, insertPrompt, editPrompt, getSelectedRowData } = usePromptModel();
    const formRef = useRef<IYhFormRef>();

    const onCancel = () => {
        setIPromptDrawer();
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then((val: ISCMPromptFormFields) => {
            let data = {...val}
            mode === "edit" ? editPrompt(data) : insertPrompt(data);
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    //错误日志类型
    const branchChange = (value: string, option: ISelectOption) => {
        option && formRef.current?.setFieldsValue({ systemName: option.namech });
    }
    const formConfig: IYhForm<ISCMPromptFormFields> = {
        formRef,
        labelCol: { span: 6 },
        formValues: mode === "edit" ? getSelectedRowData() : 
        mode === "addPeer" ? {pcode:getSelectedRowData()?.pcode}:
        {pcode:getSelectedRowData()?.errorCode,branch:getSelectedRowData()?.branch,systemName:getSelectedRowData()?.systemName},
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "分支编码",
                fieldName: "branch",
                span: 24,
                options: mdmBranch,
                onSelectChange:branchChange
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "系统名称",
                fieldName: "systemName",
                span: 24,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "父级编码",
                fieldName: "pcode",
                disable:true,
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "错误编码",
                fieldName: "errorCode",
                span: 24,
                rules: [{ required: true, message: '该项为必填项' }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "功能模块",
                fieldName: "moduleName",
                span: 24,
                rules: [{ required: true, message: '该项为必填项' }]
    
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "提示信息",
                fieldName: "promptInformation",
                span: 24,
            },
        ]
    };
    return (
        <AppDrawer
            {...{
                title: `错误日志${mode === "edit" ? "编辑" : "新增"}`,
                visible,
                onCancel,
                okText: "保存",
                onOk: onSubmit
            }}
        >
            <YhForm {...formConfig} />
        </AppDrawer>
    )
}
